import jsPDF from "jspdf";
import "jspdf-autotable";
import { createI18n } from 'vue-i18n';
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { AccountController } from "../../../../controllers/AccountController";

const generateLabelPdfSTOSC = async (
    title: string,
    data: { name: string; value: any }[],
    logo: string
) => {
    const doc = new jsPDF("p", "mm", "a5", true);
    let y = 6;

    const pdfWidth = doc.internal.pageSize.width;
    const logoProperties = doc.getImageProperties(logo);
    const logoAspectRatio = logoProperties.height / logoProperties.width;

    const imageWidth = 40;
    const imageHeight = logoAspectRatio * 40;
    doc.addImage(
        logo,
        "PNG",
        pdfWidth - imageWidth - 9,
        y,
        imageWidth,
        imageHeight,
        "logo",
        "FAST",
        0
    );
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor("#4d4d4d");

    y += 7;
    doc.text(title, 10, y);
    doc.setFillColor("#e0e0e0");

    y += 7;
    doc.rect(10, y, 190, 0.2, "F");
    doc.setFontSize(7);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);
    doc.setTextColor("#4d4d4d");

    for (const [index, item] of data.entries()) {
        y += index ? 17 : 13;

        doc.setFont("helvetica", "normal");
        doc.text(item.name, 10, y);
        doc.setFont("helvetica", "bold");
        doc.text(`: ${item.value}`, 70, y);
    }

    const i18nInstance = createI18n({
        legacy: false,
        locale: AccountController.accountData.account_type_detail?.countryCode?.toLowerCase() || 'id',
        fallbackLocale: "id",
        globalInjection: false,
        messages: { en, id, my }
    });
    const t = i18nInstance.global.t;

    y = 175;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(String(t("stoSc.pdf.signatoryStationAdmin")), 10, y);
    doc.text(String(t("stoSc.pdf.signatoryCourier")), 62, y);
    doc.text(String(t("stoSc.pdf.signatoryOpsSupervisor")), 97, y);

    y += 27;
    doc.setFontSize(8);
    doc.text("(................................)", 10, y);
    doc.text("(..........................................)", 50, y);
    doc.text("(..........................................)", 100, y);

    doc.setProperties({
        title
    });
    doc.autoPrint();
    window.open(doc.output("bloburl").toString(), "_blank");
};

export default generateLabelPdfSTOSC;
